import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"




export default /*#__PURE__*/_defineComponent({
  __name: 'BaseImagePreview',
  props: {
  imageUrl: {
    type: String,
    default: null
  },
  text: {
    type: String,
    default: ''
  }
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["flex items-center justify-center select-none text-lg font-medium leading-tight text-center text-white w-24 h-16 rounded-lg bg-no-repeat bg-center bg-cover float-left", { 'opacity-25': __props.text }]),
    style: _normalizeStyle(__props.imageUrl ? 'background-image: url(' + __props.imageUrl + ')' : '')
  }, _toDisplayString(__props.text), 7))
}
}

})